const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 0h-3v8.5H0v3h8.5V20h3v-8.5H20v-3h-8.5V0z"
      fill="currentColor"
    />
  </svg>
)

export default PlusIcon
